import { Store } from 'src/store';

const isBackdropVisible = (store: Store) => store.app.isBackdropVisible;

export default isBackdropVisible;
